export const formatPhoneNumber = (phoneNumber) => {
  const p = phoneNumber;
  // prettier-ignore
  return `${p.slice(0, 2)}(${p.slice(2, 5)})${p.slice(5, 8)}-${p.slice(8, 10)}-${p.slice(10, 12)}`;
};
